import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const router = useRouter()

// 检查登录状态
const isLoggedIn = computed(() => !!localStorage.getItem('TOKEN'))

// 滚动状态
const isScrolled = ref(false)

// 轮播图片列表
const carouselImages = ref([
  '/static/1.png',
  '/static/2.png',
  '/static/3.png'
])

// 处理图片加载错误（如果图片不存在，显示占位符）
const handleImageError = (event: Event) => {
  const target = event.target as HTMLImageElement
  // 使用占位符
  target.style.display = 'none'
  if (target.parentElement) {
    target.parentElement.style.background = '#f5f7fa'
    target.parentElement.innerHTML += '<div class="placeholder-content" style="color: #95a5a6;"><i class="el-icon-picture-outline"></i><p>应用展示图</p></div>'
  }
}

// 处理滚动事件
const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}

// 页面滚动到指定区域
const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId)
  if (element) {
    const offset = 70 // header高度
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}

// 导航方法
const goToLogin = () => {
  router.push('/login')
}

const goToPrivacy = () => {
  router.push('/privacy')
}

// 生命周期
onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

return { __sfc: true,router, isLoggedIn, isScrolled, carouselImages, handleImageError, handleScroll, scrollToSection, goToLogin, goToPrivacy }
}

})